import { useState, useEffect, useCallback } from 'react';

var API = 'https://api.algrok.com';

var STRATS = [
  { key: 'oiride', label: 'OI Ride', kind: 'flow · credit', color: '#38bdf8' },
  { key: 'oiride_d', label: 'OI Ride D', kind: 'flow · debit', color: '#a78bfa' },
  { key: 'oiride_d1', label: 'OI Ride D-1', kind: 'flow · debit', color: '#c4b5fd' },
  { key: 'oiride_r', label: 'OI Ride-R', kind: 'flow · reversed', color: '#f472b6' },
  { key: 'oiwalls', label: 'OI Walls', kind: 'structure · OI', color: '#fb923c' },
  { key: 'oiwalls3x', label: 'OI Walls 3x', kind: 'structure · OI · 3/side', color: '#fdba74' },
  { key: 'oiwalls2x', label: 'OI Walls 2X', kind: 'structure · OI · 2/side', color: '#fcd34d' },
  { key: 'gexwalls', label: 'GEX Walls', kind: 'structure · gamma', color: '#facc15' },
  { key: 'positioning', label: 'Positioning', kind: 'strangle · GEX+DEX+OI', color: '#a78bfa' },
];

function weekday(iso) {
  // new Date('2026-08-18') parses as UTC MIDNIGHT, which in any timezone west
  // of UTC lands on the previous day — and IST is east, so it is safe here,
  // but splitting the parts avoids depending on that entirely.
  try {
    var p = String(iso).split('-');
    if (p.length !== 3) return '';
    var d = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
    if (isNaN(d.getTime())) return '';
    return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()];
  } catch (e) { return ''; }
}

function fmtINR(n) {
  if (n == null || isNaN(n)) return '--';
  var sign = n < 0 ? '−' : '+';
  return sign + '₹' + Math.abs(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
}

var PaperJournal = function () {
  var [data, setData] = useState(null);
  var [err, setErr] = useState('');

  var fetchData = useCallback(function () {
    fetch(API + '/paper-journal').then(function (r) { return r.json(); }).then(function (d) {
      if (d && !d.error) { setData(d); setErr(''); } else setErr((d && d.error) || 'unavailable');
    }).catch(function () { setErr('backend unreachable'); });
  }, []);

  useEffect(function () {
    fetchData();
    var id = setInterval(fetchData, 30000);
    function wake() { if (!document.hidden) fetchData(); }
    document.addEventListener('visibilitychange', wake);
    return function () { clearInterval(id); document.removeEventListener('visibilitychange', wake); };
  }, [fetchData]);

  var days = (data && data.days) || {};
  var dates = Object.keys(days).sort().reverse();

  var summary = {};
  STRATS.forEach(function (s) { summary[s.key] = { pnl: 0, trades: 0, winDays: 0, days: 0 }; });
  dates.forEach(function (dt) {
    STRATS.forEach(function (s) {
      var r = days[dt][s.key];
      if (!r) return;
      var sm = summary[s.key];
      sm.pnl += r.day_pnl || 0;
      sm.trades += r.trades || 0;
      sm.days += 1;
      if ((r.day_pnl || 0) > 0) sm.winDays += 1;
    });
  });

  var card = { background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 12, padding: '12px 14px' };
  var th = { fontSize: 9, fontWeight: 800, letterSpacing: 0.8, color: '#556677', padding: '8px 10px', textAlign: 'right' };

  return (
    <div style={{ padding: '18px 22px', color: '#e5e7eb', fontFamily: 'inherit', maxWidth: 1250 }}>
      <div style={{ marginBottom: 14 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 22, fontWeight: 800 }}>📓 Paper Journal</span>
          <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: '#38bdf8', background: 'rgba(56,189,248,0.1)', border: '1px solid rgba(56,189,248,0.4)', borderRadius: 6, padding: '3px 8px' }}>PAPER STRATEGIES ONLY</span>
        </div>
        <div style={{ fontSize: 10, color: '#6b7a8d', marginTop: 3 }}>
          Daily record of the four signals-only experiments · separate from the real-money journal
        </div>
      </div>

      {err ? <div style={{ ...card, borderColor: 'rgba(251,191,36,0.45)', color: '#fbbf24', fontSize: 11, marginBottom: 12 }}>Paper Journal: {err}</div> : null}

      <div style={{ display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap' }}>
        {STRATS.map(function (s) {
          var sm = summary[s.key];
          return (
            <div key={s.key} style={{ flex: 1, minWidth: 190, ...card, borderTop: '2px solid ' + s.color }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <span style={{ fontSize: 12, fontWeight: 800, color: s.color }}>{s.label}</span>
                <span style={{ fontSize: 9, color: '#556677' }}>{s.kind}</span>
              </div>
              <div style={{ fontSize: 20, fontWeight: 800, marginTop: 4, color: sm.pnl >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(sm.pnl)}</div>
              <div style={{ fontSize: 10, color: '#8b98a9', marginTop: 2 }}>
                {sm.trades} trades · {sm.days ? sm.winDays + '/' + sm.days + ' green days' : 'no days yet'}
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ ...card, padding: 0, overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #1f2937' }}>
              <th style={{ ...th, textAlign: 'left' }}>DATE</th>
              {STRATS.map(function (s) { return <th key={s.key} style={{ ...th, color: s.color }}>{s.label.toUpperCase()}</th>; })}
              <th style={th}>DAY TOTAL</th>
            </tr>
          </thead>
          <tbody>
            {dates.length ? dates.map(function (dt) {
              var total = 0;
              STRATS.forEach(function (s) { total += ((days[dt][s.key] || {}).day_pnl || 0); });
              return (
                <tr key={dt} style={{ borderBottom: '1px solid #131a2a' }}>
                  <td style={{ padding: '9px 10px', color: '#c4cfd8', fontWeight: 800, whiteSpace: 'nowrap' }}>
                    {dt}
                    <span style={{ color: '#556677', fontWeight: 700, marginLeft: 6 }}>{weekday(dt)}</span>
                  </td>
                  {STRATS.map(function (s) {
                    var r = days[dt][s.key];
                    if (!r) return <td key={s.key} style={{ padding: '9px 10px', textAlign: 'right', color: '#3a4556' }}>--</td>;
                    return (
                      <td key={s.key} style={{ padding: '9px 10px', textAlign: 'right' }}>
                        <div style={{ fontWeight: 800, color: (r.day_pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(r.day_pnl)}</div>
                        <div style={{ fontSize: 9, color: '#556677' }}>
                          {r.trades} trd{r.activity ? ' · ' + r.activity + (s.key.indexOf('walls') > -1 ? ' roll' : ' flip') : ''}{r.lots > 1 ? ' · ' + r.lots + 'L' : ''}{r.sell_pnl != null ? ' · sell ' + fmtINR(r.sell_pnl) : ''}
                          {r.day_stopped ? <span style={{ color: '#ef4444' }}> · {r.day_stopped}</span> : null}
                        </div>
                      </td>
                    );
                  })}
                  <td style={{ padding: '9px 10px', textAlign: 'right', fontWeight: 800, color: total >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(total)}</td>
                </tr>
              );
            }) : (
              <tr><td colSpan={STRATS.length + 2} style={{ padding: '22px 10px', textAlign: 'center', color: '#6b7a8d', fontSize: 11 }}>
                No paper trading days recorded yet — the journal starts filling from the next market session.
              </td></tr>
            )}
          </tbody>
          {dates.length ? (
            <tfoot>
              <tr style={{ borderTop: '1px solid #26334a' }}>
                <td style={{ padding: '9px 10px', fontWeight: 800, color: '#8b98a9' }}>CUMULATIVE</td>
                {STRATS.map(function (s) {
                  return <td key={s.key} style={{ padding: '9px 10px', textAlign: 'right', fontWeight: 800, color: summary[s.key].pnl >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(summary[s.key].pnl)}</td>;
                })}
                <td style={{ padding: '9px 10px', textAlign: 'right', fontWeight: 800, color: '#38bdf8' }}>
                  {fmtINR(STRATS.reduce(function (a, s) { return a + summary[s.key].pnl; }, 0))}
                </td>
              </tr>
            </tfoot>
          ) : null}
        </table>
      </div>
    </div>
  );
};

export default PaperJournal;
